import { html, render } from "lit-html";
import { stateful } from "@escapio/shared/components/element-builder";
import { translate } from "@escapio/shared/l10n/translate";
import "../InformationDropdown";

customElements.define(
	"esc-hotel-cancelation-tooltip",
	stateful(
		class extends HTMLElement {
			static getInitialState() {
				return { showDropdown: false };
			}

			render() {
				const template = html`<span>
					<button
						@click=${this.onButtonClick}
						class="info-button"
						aria-label=${translate(
							"hotel_escapio_offer_cancelation_tooltip_aria_label",
						)}
					>
						<i class="fa fa-info-circle"></i>
					</button>
					<esc-information-dropdown
						?open=${this.showDropdown}
						@change=${this.onDropdownChange}
						info-text=${this.getAttribute("info-text")}
					></esc-information-dropdown>
				</span>`;
				render(template, this, { host: this });
			}

			onDropdownChange({ detail }) {
				this.showDropdown = detail.open;
			}

			onButtonClick(event) {
				event.stopPropagation();
				this.showDropdown = !this.showDropdown;
			}
		},
	),
);
